// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg width=\"10\" height=\"10\" viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.94064 1.6485L3.94211 9.71586L0.178504 6.91742L0.924359 5.91432L3.68487 7.96691L8.93754 0.902641L9.94064 1.6485Z\" fill=\"white\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion-container {
  flex: 1;
}
.accordion-container .add-btn {
  background-color: transparent;
  border-style: none;
  padding: 0;
  margin-bottom: 24px;
  text-decoration: underline;
}
.accordion-container .accordion-item {
  border: 1px solid #D8D9DB;
  border-radius: 5px;
  margin-bottom: 10px;
  overflow: hidden;
}
.accordion-container .accordion-item .accordion-header {
  border-bottom: 1px solid #D8D9DB;
  padding: 10px;
  cursor: pointer;
  margin-bottom: -1px;
  display: flex;
  justify-content: space-between;
}
.accordion-container .accordion-item .accordion-header .left-part,
.accordion-container .accordion-item .accordion-header .right-part {
  display: flex;
  align-items: center;
  gap: 6px;
}
.accordion-container .accordion-item .accordion-header .left-part .eleble {
  border: 1px solid #D8D9DB;
  border-radius: 2px;
  width: 20px;
  height: 20px;
  display: block;
}
.accordion-container .accordion-item .accordion-header .left-part .eleble.checked {
  background-color: var(--plus-color-purple-40);
  display: flex;
  justify-content: center;
  align-items: center;
}
.accordion-container .accordion-item .accordion-header .left-part .eleble.checked::after {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.accordion-container .accordion-item .accordion-content {
  padding: 24px;
}
.accordion-container .accordion-item .accordion-content .unit-accordion {
  margin-bottom: 12px;
}
.accordion-container .accordion-item .accordion-content .unit-accordion label.field-label {
  display: block;
  margin-bottom: 8px;
  color: #000000;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 1%;
  font-size: 16px;
}
.accordion-container .accordion-item .accordion-content .unit-accordion .checkbox-group-field {
  display: flex;
  align-items: center;
  gap: 10px;
}
.accordion-container .accordion-item .accordion-content .unit-accordion select,
.accordion-container .accordion-item .accordion-content .unit-accordion input[type=text],
.accordion-container .accordion-item .accordion-content .unit-accordion input[type=number],
.accordion-container .accordion-item .accordion-content .unit-accordion input[type=date],
.accordion-container .accordion-item .accordion-content .unit-accordion input[type=datetime-local],
.accordion-container .accordion-item .accordion-content .unit-accordion input[type=email],
.accordion-container .accordion-item .accordion-content .unit-accordion input[type=time],
.accordion-container .accordion-item .accordion-content .unit-accordion input[type=tel],
.accordion-container .accordion-item .accordion-content .unit-accordion input[type=url],
.accordion-container .accordion-item .accordion-content .unit-accordion textarea {
  width: 100%;
  max-width: unset;
}`, "",{"version":3,"sources":["webpack://./src/components/SortableAccordion/SortableAccordion.scss"],"names":[],"mappings":"AAAA;EACC,OAAA;AACD;AAAC;EACC,6BAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,0BAAA;AAEF;AAAC;EACC,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAEF;AADE;EACC,gCAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;AAGH;AAFG;;EAEC,aAAA;EACA,mBAAA;EACA,QAAA;AAIJ;AADI;EACC,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAGL;AAFK;EACC,6CAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAIN;AAHM;EACC,gDAAA;AAKP;AAEE;EACC,aAAA;AAAH;AACG;EACC,mBAAA;AACJ;AAAI;EACC,cAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAEL;AAAI;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AAEL;AAAI;;;;;;;;;;EAUC,WAAA;EACA,gBAAA;AAEL","sourcesContent":[".accordion-container {\n\tflex: 1;\n\t.add-btn {\n\t\tbackground-color: transparent;\n\t\tborder-style: none;\n\t\tpadding: 0;\n\t\tmargin-bottom: 24px;\n\t\ttext-decoration: underline;\n\t}\n\t.accordion-item {\n\t\tborder: 1px solid #D8D9DB;\n\t\tborder-radius: 5px;\n\t\tmargin-bottom: 10px;\n\t\toverflow: hidden;\n\t\t.accordion-header {\n\t\t\tborder-bottom: 1px solid #D8D9DB;\n\t\t\tpadding: 10px;\n\t\t\tcursor: pointer;\n\t\t\tmargin-bottom: -1px;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\t.left-part,\n\t\t\t.right-part  {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tgap: 6px;\n\t\t\t}\n\t\t\t.left-part {\n\t\t\t\t.eleble {\n\t\t\t\t\tborder: 1px solid #D8D9DB;\n\t\t\t\t\tborder-radius: 2px;\n\t\t\t\t\twidth: 20px;\n\t\t\t\t\theight: 20px;\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\t&.checked {\n\t\t\t\t\t\tbackground-color: var(--plus-color-purple-40);\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\tcontent: url('data:image/svg+xml,<svg width=\"10\" height=\"10\" viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.94064 1.6485L3.94211 9.71586L0.178504 6.91742L0.924359 5.91432L3.68487 7.96691L8.93754 0.902641L9.94064 1.6485Z\" fill=\"white\"/></svg>');\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.right-part {}\n\t\t}\n\t\t.accordion-content {\n\t\t\tpadding: 24px;\n\t\t\t.unit-accordion {\n\t\t\t\tmargin-bottom: 12px;\n\t\t\t\tlabel.field-label {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\tmargin-bottom: 8px;\n\t\t\t\t\tcolor: #000000;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tline-height: 20px;\n\t\t\t\t\tletter-spacing: 1%;\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t}\n\t\t\t\t.checkbox-group-field {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tgap: 10px;\n\t\t\t\t}\n\t\t\t\tselect,\n\t\t\t\tinput[type=\"text\"],\n\t\t\t\tinput[type=\"number\"],\n\t\t\t\tinput[type=\"date\"],\n\t\t\t\tinput[type=\"datetime-local\"],\n\t\t\t\tinput[type=\"email\"],\n\t\t\t\tinput[type=\"time\"],\n\t\t\t\tinput[type=\"tel\"],\n\t\t\t\tinput[type=\"url\"],\n\t\t\t\ttextarea {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tmax-width: unset;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
